import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import styled from 'styled-components';

import { colors, device } from '../../styles/stylesheets';

export const Container = styled(Accordion)`
`;
export const AccordionItemCustom = styled(AccordionItem)`
  background: ${colors.white};
  margin-bottom: 16px;
`;
export const AccordionItemHeadingCustom = styled(AccordionItemHeading)`
  line-height: 20px;
  font-size: 16px;
  @media ${device.untilTablet} {
    font-size: 14px;
  }
  @media ${device.untilMobileL} {
    font-size: 12px;
  }
`;
export const AccordionItemButtonCustom = styled(AccordionItemButton)`
  padding: 20px 20px 20px 16px;
  cursor: pointer;
  
  ::after {
    display: inline-block;
    content: '';
    height: 10px;
    width: 10px;
    margin-left: 12px;
    border-bottom: 0.4px solid ${colors.primary};
    border-right: 0.4px solid ${colors.primary};
    right: 0;

    transform: rotate(-45deg);
    transform: ${({ expanded }) => (expanded ? 'rotate(-135deg)' : 'rotate(45deg)')};
  }
`;
export const AccordionItemPanelCustom = styled(AccordionItemPanel)`
  padding: 8px 20px 20px 16px;
  font-size: 18px;
  line-height: 24px;
  color: ${colors.greyMedium};
  font-weight: 400;
  @media ${device.untilTablet} {
    font-size: 16px;
  }
  @media ${device.untilMobileL} {
    font-size: 14px;
  }
`;
export const AccordionItemStateCustom = styled(AccordionItemState)`
  padding: 8px 20px 20px 16px;
  font-size: 18px;
  line-height: 24px;
  color: ${colors.greyMedium};
  font-weight: 400;
  @media ${device.untilTablet} {
    font-size: 16px;
  }
  @media ${device.untilMobileL} {
    font-size: 14px;
  }
`;

function Faq() {
  const faqs = [
    {
      id: 1,
      question: 'Qual prazo para ter um retorno?',
      answer: 'Não temos um prazo pré estabelecido, isso pode variar muito de acordo com a qualidade de abertura do pedido, ou seja, quanto mais detalhes e informações o pedido tiver, mais rápido é o processo. Automaticamente quando você abrir um pedido, ele será encaminhado para a imobiliária que fará uma pré análise e a definição de responsabilidade de pagamento. Após isso, fará contato com o inquilino para informar se é um caso que ele deve se responsabilizar ou fará o contato com o proprietário para autorização do serviço.',
    },
    {
      id: 2,
      question: 'De quem é a responsabilidade do serviço?',
      answer: 'Cada manutenção tem suas características e as suas causas. Conforme a lei do inquilinato serviços relacionados a manutenção de itens que se desgastam com o tempo (não estruturais) e que são causados pelo uso, são de responsabilidade do inquilino. Já os problemas estruturais, ocultos, que impactem a habitabilidade do imóvel, normalmente são de responsabilidade do proprietário. A definição de responsabilidade não é uma ciência exata, é preciso analisar tempo de permanência no imóvel, se as manutenções preventivas foram executadas e ainda as anotações na vistoria que descrevem as condições de quando o inquilino entrou no imóvel em questão.',
    },
    {
      id: 3,
      question: 'As visitas são pagas?',
      answer: 'Não, nós do Triider temos uma parceria com os profissionais, por isso não existe cobrança das visitas. Se notar algum comportamento diferente disso, faça contato conosco via chat da plataforma.',
    },
    {
      id: 4,
      question: 'Como abrir um pedido?',
      answer: 'Você consegue abrir um pedido acessando a página principal da sua imobiliária. Primeiro faça login, em seguida, procure a página de “solicitar manutenção”. Depois disso, você vai acessar um ambiente do Triider através da sua imobiliária. Para abrir um pedido você coloca o seu endereço para sabermos as categorias que temos à disposição na região e em seguida escolhe a categoria de serviço, descreve seu problema com o maior número de detalhes possíveis (inclusive com fotos) e finalize a sua solicitação.',
    },
    {
      id: 5,
      question: 'Como consigo ver os orçamentos?',
      answer: 'Acessando o site ou aplicativo do Triider com o seu email cadastrado na imobiliária ou ainda diretamente pela área logada do site da sua imobiliária no menu “solicitar manutenção”. Caso você não saiba sua senha, pode escolher a opção de “esqueci minha senha” e redefini-la seguindo as instruções que serão enviadas por email.',
    },
    {
      id: 6,
      question: 'Central de atendimento',
      answer: (
        <>
          <p>
            Temos um time de atendimento à disposição para ajudá-lo. Você consegue fazer contato com
            nosso suporte: Se pelo aplicativo - acesse a aba “perfil” e entre em “preciso de ajuda”.
            Por ali você fará contato direto com nosso time;
          </p>
          <p>
            Se pelo site ou agência virtual - no canto inferior direito, você encontra o nosso chat.
          </p>
        </>
      ),
    },
  ];

  return (
    <Container allowZeroExpanded preExpanded={[faqs[0].id]}>
      {
        faqs && faqs.map(faq => (
          <AccordionItemCustom key={faq.question} uuid={faq.id}>
            <AccordionItemHeadingCustom>
              <AccordionItemStateCustom>
                {({ expanded }) => (
                  <AccordionItemButtonCustom expanded={expanded ? 1 : 0}>
                    {faq.question}
                  </AccordionItemButtonCustom>
                )}
              </AccordionItemStateCustom>
            </AccordionItemHeadingCustom>
            <AccordionItemPanelCustom>{faq.answer}</AccordionItemPanelCustom>
          </AccordionItemCustom>
        ))
      }
    </Container>
  );
}

export default Faq;
